import { Box, CircularProgress } from '@material-ui/core';

import { FileCardWrapper } from '@/components/modules/Documentation/components/DocumentationDetails/components/UploadFileManager/components/FileCardWrapper';
import { DocumentationUploadFile } from '@/components/modules/Documentation/components/DocumentationDetails/components/UploadFileManager/types/DocumentationUploadFile';
import { getMimeTypeIconNameByType } from '@/components/modules/Documentation/components/DocumentationDetails/components/UploadFileManager/utils/getMimeTypeIconNameByType';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { IconButton } from '@/components/shared/components/IconButton';

interface NonUploadedFileCardProps {
  file: DocumentationUploadFile;
  removeFileFromContext: () => void;
  loading: boolean;
}

export const NonUploadedFileCard = ({ file, removeFileFromContext, loading }: NonUploadedFileCardProps) => {
  return (
    <FileCardWrapper>
      <FlexRow justifyContent={'flex-start'} flexGrow={1} minWidth={0} overflow={'hidden'}>
        <Icon>{getMimeTypeIconNameByType(file.mimeType)}</Icon>
        <Font variant={'caption'} className="overflow-text-ellipsis pr-3" style={{ minWidth: 0 }}>
          {file.name}
        </Font>
      </FlexRow>
      <Box display={'flex'} flexDirection={'row'} alignItems={'center'} justifyContent={'flex-end'} flexShrink={0}>
        <Font variant={'caption'} style={{ paddingRight: '12px' }}>{`${(file.size / 1000).toFixed(2)} kB`}</Font>
        {removeFileFromContext && (
          <Box width={24} height={24}>
            {loading ? (
              <CircularProgress size={20} color={'secondary'} />
            ) : (
              <IconButton
                onClick={() => removeFileFromContext()}
                icon="delete"
                iconProps={{ size: 20 }}
                style={{ height: 20, width: 20 }}
              />
            )}
          </Box>
        )}
      </Box>
    </FileCardWrapper>
  );
};
